import { render } from "./loginitem.vue?vue&type=template&id=966982fe&scoped=true"
import script from "./loginitem.vue?vue&type=script&lang=js"
export * from "./loginitem.vue?vue&type=script&lang=js"

import "./loginitem.vue?vue&type=style&index=0&id=966982fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-966982fe"

export default script